<div class="bulk-message-dialog-container">
  <div class="flex flex-col w-full">
    <!-- Close button -->
    <div class="flex justify-between mb-2">
      <!-- Header -->
      <ui-paragraph type="p24" font-weight="semibold" text-color="neutrals-900">
        Responder a todos los leads
      </ui-paragraph>
      <button (click)="closeModal()">
        <ui-icon name="close" fill="neutrals-900" m-size="24" size="24" />
      </button>
    </div>

    <!-- Chip -->
    <div
      class="inline-flex w-max items-center gap-2 px-4 py-2 rounded-full bg-[#F1F4FF] mb-4"
    >
      <span class="w-3 h-3 rounded-full bg-[#2849FF]"></span>
      <ui-paragraph type="p12" font-weight="regular" text-color="neutrals-900">
        {{ stageName }}
      </ui-paragraph>
    </div>

    <div *ngIf="leadsWithoutTemplate && leadsWithoutTemplate.length > 0">
      <!-- Label -->
      <ui-paragraph type="p14" font-weight="regular" text-color="neutrals-700">
        Mensaje
      </ui-paragraph>

      <!-- Textarea wrapper -->
      <div class="relative">
        <textarea
          [(ngModel)]="message"
          rows="4"
          class="w-full rounded-2xl bg-[#F7FAFF] px-4 py-3 pr-12 border border-transparent focus:border-[#C9D7F5] focus:outline-none text-[#0B2343] resize-none"
          placeholder="Escribe tu mensaje..."
        ></textarea>

        <button
          class="hover:scale-110 absolute top-3 right-3 text-2xl"
          type="button"
          matTooltip="Emoticones"
          (click)="toggleEmojiPicker($event)"
        >
          <ui-icon
            name="face-happy"
            fill="neutrals-600"
            size="24"
            m-size="24"
          />
        </button>

        <!-- Simple emoji picker dropdown (shows when showEmojiPicker is true) -->
        <div
          *ngIf="showEmojiPicker"
          class="absolute top-12 right-3 bg-white border rounded-lg shadow-lg p-2 z-50"
          style="width: 500px; height: 200px; overflow: auto"
          (click)="$event.stopPropagation()"
        >
          <div class="grid grid-cols-6 gap-1">
            <button
              *ngFor="let e of emojiList"
              class="p-1 text-lg hover:bg-gray-100 rounded"
              type="button"
              (click)="onEmojiSelect({ native: e })"
              aria-label="Insert emoji {{ e }}"
            >
              {{ e }}
            </button>
          </div>
        </div>

        <!-- Leads info -->
        <p class="mt-3 text-[#627490] info-text">
          Se enviará a
          <span class="font-semibold text-[#0B2343]"
            >{{ leadsWithoutTemplate.length }} leads</span
          >
          este mensaje
        </p>
      </div>
    </div>

    <div *ngIf="leadsWithTemplate && leadsWithTemplate.length > 0">
      <!-- Divider -->
      <div
        *ngIf="leadsWithoutTemplate && leadsWithoutTemplate.length !== 0"
        class="my-6 border-t border-gray-200"
      ></div>

      <!-- Warning text -->
      <ui-paragraph
        type="p14"
        font-weight="regular"
        text-color="neutrals-700"
        class="mb-4"
      >
        Existen leads con un bloqueo de Whatsapp por no responder en 24 h, en
        estos casos se debe enviará la plantilla determinada.
      </ui-paragraph>

      <!-- Template selector (radio-box style) -->
      <div
        class="border rounded-2xl px-4 py-3 flex items-center gap-3 cursor-pointer hover:border-[#2849FF] mb-3"
        (click)="selectedTemplate = 'Saludo'"
        [class.border-[#2849FF]]="selectedTemplate === 'Saludo'"
      >
        <span
          class="w-5 h-5 rounded-full border flex items-center justify-center"
          [class.border-[#2849FF]]="selectedTemplate === 'Saludo'"
        >
          <span
            *ngIf="selectedTemplate === 'Saludo'"
            class="w-3 h-3 rounded-full bg-[#2849FF]"
          ></span>
        </span>

        <span class="font-medium text-[#0B2343]">Saludo</span>
      </div>

      <!-- Leads count (blocked) -->
      <p class="text-[#6A7280] info-text mb-4">
        Se enviará a
        <span class="font-semibold text-[#0B2343]"
          >{{ leadsWithTemplate.length }} leads</span
        >
        este mensaje.
      </p>
    </div>

    <!-- Button -->
    <div class="flex justify-end">
      <button
        (click)="onSend()"
        class="flex justify-center w-[200px] bg-[#F3D572] hover:bg-[#e9c760] text-[#0B2343] font-semibold px-10 py-3 rounded-xl transition-all"
      >
        <ng-container *ngIf="isLoading; else showText">
          <ui-loader type="primary" size="md" />
        </ng-container>
        <ng-template #showText>
          <ui-paragraph
            type="p14"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            Enviar a todos
          </ui-paragraph>
        </ng-template>
      </button>
    </div>
  </div>
</div>
